export default __webpack_public_path__ + "static/media/license-plate-fill.9658c41c.svg";